define('root/contacts/Podio.SpaceContacts',['require','translate','lib/Podio.Transport.SpaceContacts','lib/Podio.UI.SpaceContactModal','lib/Podio.UI.Modal','lib/Podio.UI.ActionDropdown','lib/Podio.UI.FlashMessage','lib/Podio.Event.UI','lib/Podio.UI.LeftNavigation'],function(require) {

  var t = require('translate');
  var SpaceContactsTransport = require('lib/Podio.Transport.SpaceContacts');
  var SpaceContactModal = require('lib/Podio.UI.SpaceContactModal');
  var modal = require('lib/Podio.UI.Modal');
  var actionDropdown = require('lib/Podio.UI.ActionDropdown');
  var flashMessage = require('lib/Podio.UI.FlashMessage');
  var eventUI = require('lib/Podio.Event.UI');
  var leftNavigation = require('lib/Podio.UI.LeftNavigation');

  function onAddNewSpaceContactClicked(elmTarget, e) {
    SpaceContactModal.newModal({
      space_id: elmTarget.data('space-id'),
      callback: function(responseData) {
        location.href = responseData.data.redirect_to;
      }
    });
  }

  function onSpaceContactActionClicked(action, elmTarget, e) {
    actionDropdown.hideAll();

    var space_id = elmTarget.parents('ul.summary-badge-list').data('state-space-id');
    var elmContactLi = elmTarget.parents('li.contact:first');
    var profile_id = elmContactLi.data('profile-id');
    var type = 'space';
    if (elmTarget.data('type') === 'item') {
      type = 'item';
    }
    if (elmTarget.parents('ul.summary-badge-list').data('standalone')) {
      type = 'expanded';
    }

    switch (action) {
    case 'edit':
      SpaceContactModal.editModal({ 'type': type, 'space_id': space_id, 'profile_id': profile_id, callback: function(responseData) {
        elmContactLi.replaceWith(responseData.data.html);
      }});
      break;
    case 'delete':
      modal.showConfirm(t('Delete space contact #space_contact'), t('You are about to delete this space contact #space_contact'), null, {yes: t('Ok, delete #space_contact'), no: t('Cancel #space_contact') }, function() {
        SpaceContactsTransport.deleteSpaceContact(space_id, profile_id, function(responseData) {
          var space_contact = responseData.data.space_contact;
          elmContactLi.remove();
          flashMessage.show(t('Successfully deleted %{contact_name}. #space_contact').replace('%{contact_name}', space_contact.name), 'notice');
        });
      });
      break;
    }
  }

  function onLeaveSpaceClicked(elmTarget, e) {
    leftNavigation.leaveSpace(elmTarget, e);
  }

  // Buttons
  eventUI.bind('click', '#add_space_contact_button', onAddNewSpaceContactClicked);
  eventUI.bind('click', '#leave_space_button', onLeaveSpaceClicked);

  // Actions
  eventUI.bind('click', '.contacts .actions li.edit-space-contact', onSpaceContactActionClicked.curry('edit'));
  eventUI.bind('click', '.contacts .actions li.delete-space-contact', onSpaceContactActionClicked.curry('delete'));

});

